<template>
  <div class="page-wrap">
    <div class="payStatus" v-if="payStatus != 0">
      <div v-if="payStatus == 1">
        <img
          src="../../assets/images/pay-success.png"
          alt=""
          class="suc-logo"
        />
        <div class="status-text">支付成功！</div>
      </div>
      <div v-else>
        <img
          src="../../assets/images/pay-error.png"
          alt=""
          class="store-logo"
        />
        <div class="status-text">支付失败！</div>
      </div>
    </div>
    <div class="page-load" v-else-if="pageLoading == 1">
      <img src="../../assets/images/loading.png" class="page-load_icon" />
    </div>
    <div class="notData" v-else-if="pageLoading == 2">
      {{ errMsg || "获取失败请稍后重试！" }}
    </div>

    <template v-else>
      <div class="bg-color">
        <img src="../../assets/images/logo-tp.png" class="bg-img" />
      </div>
      <div class="page-view">
        <div class="pay-banner">
          <img src="../../assets/images/logo.png" class="pay-banner__logo" />
          <div class="pay-banner__sub">为您提供更高效<span class="dot">丨</span>更安全<span class="dot" >丨</span>更便捷的服务</div>
        </div>

        <div class="pay-card">
          <div class="bg-white pay-card-amount">
            <div class="title">缴费信息</div>
            <div class="price">
              <span class="symbol">￥</span>
              <span class="num">{{ totalPrice.intNumb}}</span>
              <span class="dec" v-if="totalPrice.decNumb">{{totalPrice.decNumb}}</span>
            </div>
          </div>

          <div class='separation'>
            <div class="separation-left"></div>
            <div class='separation-box'>
               <div class='separation-line'></div>
            </div>
            <div class="separation-right"></div>
          </div>

          <div class="bg-white pay-card-details">
            <!-- <div class="labelItem">
              <span class="labelName">客户ID</span>
              <div class="labelContent">{{ feeInfo.clientId }}</div>
            </div> -->
            <div class="labelItem">
              <span class="labelName">客户名称</span>
              <div class="labelContent">{{ feeInfo.clientName }}</div>
            </div>
            <div class="labelItem">
              <span class="labelName">联系手机</span>
              <div class="labelContent">{{ feeInfo.mobileNo }}</div>
            </div>
      
            <div class="labelItem" v-if="pageNav != 2">
              <span class="labelName">{{labelList[pageNav].qty}}</span>
              <div class="labelContent">
                <span>{{ feeInfo.qty }}</span>
              </div>
            </div>
              <div class="labelItem">
              <span class="labelName">{{labelList[pageNav].price}}</span>
              <div class="labelContent">
                <span>￥{{ feeInfo.price }}{{pageNav==3?'/条':''}}</span>
              </div>
            </div>

          </div>
        </div>

        <!-- 底部 分享、支付 -->
        <div class="oper-bottom_back"></div>
        <div class="oper-bottom" :class="['color' + pageNav]">
          <div class="row">
            <!-- <div>
              <span v-if="totalPrice.payment">
                <span>合计：</span>
                <span class="fc-main price">
                  <span>￥</span>
                  <span class="numb">{{ totalPrice.intNumb }}</span>
                  <span>{{ totalPrice.decNumb }}</span>
                </span>
              </span>
            </div> -->
            <button
              class="bg-main btn"
              :disabled="!totalPrice.payment || btnDisabled"
              @click="handerPay">{{ btnDisabled ? "支付中.." : "立即支付" }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getOpenIdApi,
  queryRechargeDetailApi,
  createOrderApi,
  linfengPayApi,
} from "@/request/api";
import { Toast } from "vant";
export default {
  name: "",
  components: {},
  data() {
    return {
      labelList:[
        {qty:"购买软件站点", price:"软件站点费价格"},
        {qty:"缴纳软件服务数量", price:"软件服务费价格"},
        {qty:"小程序费用", price:"小程序费用"},
        {qty:"购买数量", price:"价格"},
      ],
      pageNav: 1, //0站点费、1服务费、2小程序费用、3短信费
      appId: "wxad104e066a4e583a", //公众号appId
      flowId: "",
      pageLoading: 1, //0 加载完成 1 加载中 2失败
      payStatus: 0, // 0：未支付 1：已支付 2：支付失败
      errMsg: "",

      code: "", //公众号code
      openId: "", //公众号openId

      feeInfo: {}, //费用类型缴费金额
      feeNumber: "",
      totalPrice: {
        intNumb: "",
        decNumb: "",
        payment: "",
      },
      btnDisabled: false,

      enrollState: 1, //0未注册的（代表客户）
    };
  },
  mounted() {},
  created() {
    this.flowId = this.$route["query"]["key"];
    if (!this.flowId) {
      this.errMsg = "参数错误，请联系客服重新获取链接";
      this.pageLoading = 2;
      return;
    }
    this.IsWeixinOrAlipay();
  },
  methods: {
    //判断扫码环境
    IsWeixinOrAlipay() {
      let that = this;
      var ua = window.navigator.userAgent.toLowerCase();
      let platform = "";
      //判断是不是微信
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        platform = "WX";
      }

      // localStorage.removeItem("openId");
      if (platform == "WX") {
        //查询缓存中是否存在openid，存在则执行业务操作，不存在则获取code，请求接口获得openid操作
        that.openId = localStorage.getItem("openId");

        if (
          !that.openId ||
          that.openId == "" ||
          that.openId == null ||
          that.openId == undefined ||
          that.openId == "null"
        ) {
          //获取微信openid
          that.getBaseInfos();
        } else {
          that.getRechargeDetail(); //获取信息
        }
      } else {
        //哪个都不是
        that.$router.replace({
          path: "/unableplat",
        });
      }
    },

    getRechargeDetail() {
      queryRechargeDetailApi({
        flowId: this.flowId,
      })
        .then((res) => {
          if (res.code == 200) {
            let pageNav = res.data.feeType;
            // ["缴站点费", "服务费", "小程序费", "短信费"]
            let title =["软件站点费", "软件服务费", "小程序费", "信息技术服务费"][pageNav] || "天美联盟软件";

            document.title = title;

            //  pageTitle: title,
            this.pageNav = pageNav;
            this.pageLoading = 0;
            this.feeInfo = res.data;
            this.payStatus = res.data.payStatus || 0;
            this.countSum(res.data.payment);
          } else {
            this.pageLoading = 2;
            this.errMsg = res.msg;
          }
        })
        .catch((err) => {
          this.pageLoading = 2;
          this.errMsg = "请求网络繁忙，请稍后再试！";
        });
    },

    //获取code
    getBaseInfos() {
      let that = this;
      let url = window.location.href;
      that.code = that.getUrlParam("code");
      if (that.code) {
        that.getRechargeDetail(); //获取信息
        that.getOpenId(); //继续下一步获取openid
      } else {
        var url_code =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          that.appId +
          "&redirect_uri=" +
          that.urlencode(url) +
          "&response_type=code&scope=snsapi_base&state=h5#wechat_redirect";
        window.location.replace(url_code); //打开这个链接，你的url后面就会跟上code的参数
      }
    },
    //获取openid
    getOpenId() {
      let that = this;
      const para = {
        code: that.code,
        payType: "WX",
      };
      getOpenIdApi(para).then((res) => {
        if (res.code == 200) {
          if (
            res.data &&
            res.data != "" &&
            res.data != "null" &&
            res.data != null &&
            res.data != undefined
          ) {
            that.openId = res.data;
            localStorage.setItem("openId", that.openId); //缓存openid
          }
        } else {
          Toast(res.msg || "获取登录信息繁忙，请稍后重试！");
        }
      });
    },
    //编码函数
    urlencode(str) {
      str = (str + "").toString();
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A")
        .replace(/%20/g, "+");
    },
    //获取url链接中的参数，二维码中的参数
    getUrlParam(key) {
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },

    countSum(price) {
      let str = price.toString().split(".");
      this.totalPrice = {
        intNumb: str[0],
        decNumb: str[1] ? "." + str[1] : "",
        payment: price,
      };
    },
    //支付
    handerPay() {
      if (this.btnDisabled) {
        return;
      }
      this.btnDisabled = true;
      let feeInfo = this.feeInfo;

      createOrderApi({ flowId: this.flowId })
        .then((order_res) => {
          if (order_res.code == 200) {
            linfengPayApi({
              appId: this.appId,
              outerTradeId: order_res.data.tradeId,
              flowId: feeInfo.flowId,
              payment: feeInfo.payment,
              price: feeInfo.price,
              qty: feeInfo.qty,
              openId:this.openId,
              // openId: "oUomc6eY90bXJXjdR7wMD_blrxrc",
            })
              .then((res) => {
                this.goWxpay({
                  timeStamp: res.data.timeStamp,
                  package: "prepay_id=" + res.data.prepayId,
                  paySign: res.data.paySign,
                  appId: this.appId,
                  signType: res.data.signType,
                  nonceStr: res.data.nonceStr,
                });
              })
              .catch((err) => {
                this.btnDisabled = false;
              });
          } else {
            this.btnDisabled = false;
          }
        })
        .catch((err) => {
          this.btnDisabled = false;
        });
    },

    //唤起微信支付
    goWxpay(jsApiPayInfo) {
      let that = this;
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        jsApiPayInfo,
        function (res) {
          // Toast('支付回调参数：'+JSON.stringify(res));
          //成功后返回ok，但并不保证它绝对可靠，继续请求接口查询是否真的支付成功
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            that.getRechargeDetail();
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            //取消支付
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            that.getRechargeDetail();
            //支付失败
            Toast("支付失败:" + JSON.stringify(res));
          }
          that.btnDisabled = false;
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  font-size: 28px;
  position: relative;
  min-height: 500px;
  padding-bottom: 60px;
}

// 支付状态
.payStatus {
  text-align: center;
  .suc-logo {
    margin-top: 78px;
    width: 104px;
    height: 87px;
    margin-bottom: 41px;
  }
  .store-logo {
    margin-top: 65px;
    width: 106px;
    height: 106px;
    margin-bottom: 35px;
  }
  .load-err {
    margin-top: 66px;
    width: 361px;
    height: 326px;
    margin-bottom: 56px;
  }
  .status-text {
    font-size: 36px;
    font-weight: bold;
    color: #FA3474;
  }
  .load-text {
    font-size: 36px;
    font-weight: bold;
    color: #999999;
  }
}

// 付款内容
.row {
  display: flex;
  flex-flow: wrap row;
}
.rowCenter {
  display: flex;
  flex-direction: row;
  align-items: center;
}
button {
  outline: none;
  border: none;
}

.bg-color {
  width: 100%;
  height: 80%;
  background: linear-gradient(#fa3474 0%, #fe9eaf 65%, #f3f3f3 100%);
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  text-align: center;
  overflow: hidden;
  padding-top: 32px;
  .bg-img {
    width: 85%;
    height: auto;
    object-fit: cover;
  }
}
.page-view {
  position: relative;
  z-index: 1;
}

/* 顶部  */
.pay-banner {
  position: relative;
  width: 100%;
  padding: 158px 0 36px;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}
.pay-banner__logo {
  width: 45%;
  height: auto;
  margin-bottom: 36px;
}

.pay-banner__sub {
  text-align: center;
  margin: auto;
  line-height: 1.2;
  color: #fff;
  display: flex;
  align-items: center;
  .dot {
    margin: 0 6px;
    font-weight: 500;
  }
}

.pay-card{
  margin: 0 30px;
  border-radius: 20px;
  overflow: hidden;
}


/* 分隔线  */
.separation{
  width: 100%;
  overflow: hidden;
  position: relative;
}
.separation-left,.separation-right{
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: solid 13px #fff;
  position: absolute;
  top: -12px;
  
}

.separation-left{
 left: -26px;
}
.separation-right{
 right: -26px;
}
.separation-box{
  background-color: #fff;
  height: 32px;
  display: flex;
  align-items: center;
  margin: 0 16px;
  padding: 0 20px;
}
.separation-line{
  flex: 1;
  border-bottom: dashed 1px #dcdcdc;
  margin: 0 0 2px;
}

/* 总金额 */
.pay-card-amount {
  font-weight: 800;
  line-height: 1;
  padding: 44px 0 28px;
  .title {
    font-size: 42px;
    margin-bottom: 42px;
    text-align: center;
  }
  .price {
    display: flex;
    align-items: baseline;
    justify-content: center;
    font-size: 42px;
    .symbol {
      margin-right: 3px;
    }
    .num {
      font-size: 80px;
      
    }
  }
}

.bg-white {
  background-color: #fff;
}
.labelItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: solid 1px #dcdcdc;
  padding: 34px 3px;
  margin: 0 30px;
}
.labelItem:first-child{
  padding-top: 24px;
}
.pay-card .labelItem:last-child {
  border-bottom: none;
}


.labelName {
  flex: none;
}
.arrow-icon {
  width: 26px;
  height: 26px;
}
.warn-icon {
  width: 45px;
  height: 38px;
  margin-right: 12px;
  flex: none;
}

/* 底部操作 */
.oper-bottom_back {
  min-height: 120px;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
}

.oper-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 90;
  background-color: #fff;
  min-height: 120px;
  padding: 21px 30px env(safe-area-inset-bottom);
  font-size: 30px;
  font-weight: 700;
}
// .oper-bottom .price {
//   color: #07c160;
// }
// .oper-bottom .numb {
//   font-size: 46px;
// }

.oper-bottom .btn {
  width: 100%;
  height: 78px;
  line-height: 78px;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
  padding: 0;
  margin: 0;
  border-radius: 40px;
  text-align: center;
  background-color: #FA3474;
}
.oper-bottom button[disabled] {
  background-color: #999;
  color: #fff;
}

// .feeType-0,
// .feeType-1,
// .feeType-2 {
//   margin-top: 24px;
// }

/* 
* 短信费
*/
// .feeType-3 {
//   padding-bottom: 10px;
// }
// .feeType-3 .dataItem {
//   background-color: #fff;
//   margin: 30px 30px 0;
//   border-radius: 12px;
//   padding: 40px 30px;
//   font-size: 26px;
// }
// .feeType-3 .number {
//   color: #fa3b79;
//   font-weight: 700;
//   font-size: 48px;
//   margin: 0 4px;
// }
// .feeType-3 .tips {
//   color: #999;
// }

/* 加载中 */
.page-load {
  padding-bottom: 20px;
  margin: 80px 0 30px;
  text-align: center;
}
.page-load_2 {
  padding: 28px 0;
  text-align: center;
}

.page-load_icon {
  width: 52px;
  height: 52px;
  display: inline-block;
  margin: auto;
  animation: load_img linear infinite 1s;
}

@keyframes load_img {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.notData,
.noData {
  padding: 80px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
  color: #666;
}
</style>